<div class="atn-ds-table-icons-renderer">
  @for (iconConfig of iconConfigsSg(); track $index) {
    <i
      class="atn-ds-table-icons-renderer__icon {{ iconConfig.class }}"
      [class.atn-ds-table-icons-renderer__icon--disabled]="iconConfig.disabled"
      [class.atn-ds-table-icons-renderer__icon--loading]="iconConfig.loading"
      [attr.title]="iconConfig.title"
      style="padding: 5px"
      (click)="
        $event.stopPropagation();
        !iconConfig.disabled && !iconConfig.loading && iconConfig.onClick()
      "
    ></i>
  }
</div>
